import React from 'react';
import * as config from '../../config.js';
import { useSelector, useDispatch } from 'react-redux';
import { Color } from '../color/Color';
import axios from 'axios';
import {
  setOutterline,
  getOutterline,
  getOutterlineColorGroup,
  getSelectedColorId,
  getSimplify,
  getResize,
  setResizeAsRatio,
  getWorkId,
  setSvg,
  setSimplify,
} from './formDataSlice';
import {
  selectColor,
} from '../color/colorSlice';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Input,
  Box,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function FormData() {
  const dispatch = useDispatch();
  const outterline = useSelector(getOutterline);
  const outterlineColorGroup = useSelector(getOutterlineColorGroup);
  const selectedColorId = useSelector(getSelectedColorId);
  const simplify = useSelector(getSimplify);
  const resize = useSelector(getResize);
  const workId = useSelector(getWorkId);
  const colors = useSelector(selectColor);
  
  const disabledForm = colors.length == 0 ? true : false;
  const disabledButton = selectedColorId.length == 0 ? true : false;

  const handleChange = (event) => {
    dispatch(setOutterline(event.target.value == "true" ? true : false));
  };
  const changeInput = (e, index) => {
    const { value } = e.target;
    const onlyNumber = parseInt(value.replace(/[^0-9]/g, ''));
    dispatch(setResizeAsRatio({index:index,value:onlyNumber}))
  };
  const startConverting = () =>{

    setLoading(true);
    if(selectedColorId.length == 0){
      alert('Choose more than one color')
      setLoading(false);
      return;
    }
    let data = {
      "work-id": workId,
      "selected-layout-ids": selectedColorId,
      "outterline": outterline,
      "resize": resize,
      "parameters": {
        // "ocr": {
        //   "gpu": false,
        //   "threshold-score": 0.3,
        //   "text-box-margin": 0
        // },
        // "postprocess-layout": {
        //   "open-kernel-size": 3,
        //   "close-kernel-size": 7,
        //   "segment-close-kernel-size": 9,
        //   "min-layout-area": 100,
        //   "max-layout-area-fill": 900
        // },
        "svg-converter": {
          "simplify-tolerance": simplify
        }
      }
    };
    // remove empty array to post
    if(outterline){
      let removeEmptyOutterLineColorGroup = outterlineColorGroup.filter(item => item.length > 0);
      data["outterline-layout-group"] = removeEmptyOutterLineColorGroup;
    }
    axios.post(config.SERVER_API+'api/layout-parser/parse', data)
    .then(function (response) {
        let svg = response.data;
        let blob = new Blob([svg], {type: 'image/svg+xml'});
        let url = URL.createObjectURL(blob);
        dispatch(setSvg(url));
        setLoading(false);
    })
    .catch(function (error) {
        console.log(error);
        setLoading(false);
    });
  }
  const [loading, setLoading] = React.useState(false);
  function handleClick() {
    setLoading(true);
  }
  const changeSimplify = (e) => {
    const { value } = e.target;
    const onlyNumber = parseInt(value.replace(/[^0-9]/g, ''));
    dispatch(setSimplify(onlyNumber));
  };

  return (
    <section className="container" style={{position:'relative', height:"100%"}} >
      <TableContainer component={Paper}>
        <Table sx={{  }} aria-label="simple table">
          <TableBody>
            <TableRow key={0} >
              <TableCell component="th" scope="row">
              Work ID
              </TableCell>
              <TableCell colSpan={2} align="right">
                <Input
                  disabled={true}
                  fullWidth
                  value={workId}
                />
              </TableCell>
            </TableRow>
            <TableRow key={1} >
              <TableCell component="th" scope="row">
              Size
              </TableCell>
              <TableCell align="right">
                <Input
                  disabled={disabledForm}
                  fullWidth
                  value={resize[0]}
                  onChange={(e) => changeInput(e, 0)}
                />
              </TableCell>
              <TableCell align="right">
                <Input
                  disabled={disabledForm}
                  fullWidth
                  value={resize[1]}
                  onChange={(e) => changeInput(e, 1)}
                />
              </TableCell>
            </TableRow>
            <TableRow key={2} >
              <TableCell component="th" scope="row">
              Shape
              </TableCell>
              <TableCell colSpan={2} align="right">
                <RadioGroup
                  row
                  aria-label="gender"
                  name="controlled-radio-buttons-group"
                  value={outterline}
                  onChange={handleChange}
                >
                  <FormControlLabel disabled={disabledForm} value={true} control={<Radio style={{color:config.DABEEO_COLOR}}/>} label="outerLine" />
                  <FormControlLabel disabled={disabledForm} value={false} control={<Radio style={{color:config.DABEEO_COLOR}} />} label="innerLine" />
                </RadioGroup>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box >
        <Color disabledForm={disabledForm} />
      </Box>
      <TableContainer component={Paper} style={{position:'absolute', bottom:"0"}}>
        <Table sx={{  }} aria-label="simple table">
          <TableBody>
            <TableRow key={3} > 
                <TableCell align="left">
                  <TextField
                    fullWidth
                    disabled={disabledForm}
                    id="outlined-number"
                    label="Simplify (default: 5) "
                    type="number"
                    value={simplify}
                    onChange={(e) => changeSimplify(e)}
                  />
                </TableCell>
                <TableCell scope="row">
                  <LoadingButton
                    fullWidth
                    disabled={disabledButton}
                    onClick={startConverting}
                    endIcon={<ArrowBackIcon />}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    3. Start Converting
                  </LoadingButton>
                </TableCell>
              </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </section>
  );
}
